<template>
  <v-row>
    <v-col v-if="campaigns.length > 0" cols="12" class="mt-5">
      <v-row>
        <v-col cols="2" style="color: #666;">KHUYẾN MẠI ÁP DỤNG:</v-col>
        <v-col cols="10" class="py-0">
          <v-row v-for="item in campaigns" :key="item.code">
            <v-col cols="3" class="pt-1">
              <div style="background-color: #FFECDB; border-radius: 20px; min-width: 80px;height: 40px" class="text-center pt-2" @click="showDetailKM(item)">
                {{ getCode(item) }}
              </div>
            </v-col>
            <v-col cols="9">
              <div v-if="gifts.length > 0 && item.giftSelected.length">
                <span class="mr-2">Sản phẩm tặng kèm:</span>
                <span>{{ gifts(item) }}</span>
              </div>
              <div v-else>
                <span class="mr-2">Giảm giá sản phẩm:</span>
                <span v-if="isPercent(item)">{{ discount(item) }} %</span>
                <span v-else>{{ formatCurrency(discount(item)) }}</span>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col v-if="!isDetail" cols="12" class="pt-5">
      <div class="campaign-select" @click="select">
        <v-icon color="#0075ff">mdi-tag-plus</v-icon>
        <span class="campaign-title ml-2">Chọn khuyến mại</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { CampaignType, getDiscount } from '@/helpers/campaign';
export default {
  props: {
    isDetail: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    campaigns() {
      return this.product?.campaigns || [];
    },
    campaign() {
      return this.campaigns?.length > 0 ? this.campaigns[0].raw : null;
    },
  },
  methods: {
    getCode(item) {
      if (!item) return '';
      if (item.raw.promotionSubCode) {
        return item.raw.promotionSubCode;
      }
      return item.raw?.promotionCode;
    },
    select() {
      this.$emit('select');
    },
    gifts(item) {
      const cpg = item;
      let gifts = cpg?.giftSelected || [];
      return gifts.map(it => {
        return (it.quantity || 1) + ' x ' + (it.skuName || '');
      }).join(', ');
    },
    isPercent(item) {
      return item.raw.type == CampaignType.PERCENT;
    },
    discount(item) {
      return item.raw?.promotionDiscount || 0;
    },
    showDetailKM(item) {
      if (!this.isDetail) return;
      this.$emit('showDetailKM', { campaign: item, product: this.product });
    },
  }
}
</script>

<style lang="scss" scoped>
.campaign-select {
  display: inline-flex;
  align-items: center;
  padding: .25rem 1rem;
  border: 1px solid #0075ff;
  border-radius: .5rem;
  color: #0075ff;
  cursor: pointer;
  user-select: none;
}
.campaign-title {
  display: block;
  margin: 0;
  padding: 0;
  height: 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  color: inherit;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}
</style>
